module.exports = __webpack_public_path__ + "static/story5-menu-thumbnails-400x400-15ca4b37fe1666b42f8238fab5e6ee85.jpg";